import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { TDWActionType, TDWModuleType, TDWOperationType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { DataType } from '@tencent/slide-sdk-model';

export default class PresentationInfoCollector {
    public static instance;
    public static getInstance() {
        if (!PresentationInfoCollector.instance) {
            PresentationInfoCollector.instance = new PresentationInfoCollector();
        }
        return PresentationInfoCollector.instance;
    }

    private static maxMinAvg(numArr) {
        let [max] = numArr;
        let [min] = numArr;
        let [sum] = numArr;
        for (let i = 1; i < numArr.length; i++) {
            if (numArr[i] > max) {
                max = numArr[i];
            }
            if (numArr[i] < min) {
                min = numArr[i];
            }
            sum = sum + numArr[i];
        }
        return {
            max,
            min,
            sum,
            avg: sum / numArr.length,
        };
    }

    private isStart = false;

    private collected = false;
    /**
     * 统计元素信息
     */
    public collectElementInfo(presentation) {
        if (this.checkNeedCollect()) {
            this.isStart = true;
            this.startCollection(presentation);
        }
    }

    private checkNeedCollect() { // 只有非调试模式才会走
        return !this.collected && !this.isStart && !__IS_DEV__;
    }

    private collectGroup(group) {
        let number = 0;
        group.shapeList.forEach((item) => {
            if (item.type === DataType.GroupShape) {
                number += this.collectGroup(item);
            } else if (item.type === DataType.GraphicalObjectFrameTable) {
                number += (item.colLength) * (item.rowLength);
            } else {
                number += 1;
            }
        });
        return number;
    }

    private getInheritElementNumber(slide) {
        let layoutElementNum = 0;
        let masterElementNum = 0;
        const layout = slide?.getLayout();
        if (layout) {
            layoutElementNum = this.collectGroup(layout);
            const master = layout.getMaster();
            masterElementNum = this.collectGroup(master);
        }
        return layoutElementNum + masterElementNum;
    }

    private startCollection(sdkPresentation) {
        try {
            const numArray: number[] = [];
            sdkPresentation.slideList.forEach((slide) => {
                const slideElementNum = this.collectGroup(slide);
                const inheritElementNum = this.getInheritElementNumber(slide);
                numArray.push(slideElementNum + inheritElementNum);
            });
            this.reportAfterCollection(numArray);
        } catch (e) {
            window.log?.error(`[collect-presentation-info-error]${e}`);
        }
    }

    /**
     * 上报数据
     * @param numArray
     */
    private reportAfterCollection(numArray) {
        this.isStart = false;
        this.collected = true;
        const { max, min, avg, sum } = PresentationInfoCollector.maxMinAvg(numArray);
        const slideCount = numArray.length;
        tdw({
            opername: TDWOperationType.DOC_PERFORMANCE,
            module: TDWModuleType.PERFORMANCE_DETAIL,
            action: TDWActionType.PERFORMANCE_ELEMENT_INFO,
            ver5: 0,
            ver6: JSON.stringify({
                slideCount,
                max,
                min,
                avg,
                sum,
            }),
        });
    }
}
